import angular from 'angular';
import geolocation from 'angularjs-geolocation';

// Libraries

// Translations
import translation from '../../../../../lib/translation';

// Load all services
import '../../../../../lib/service';
import taskQueueServiceModule from '../../../../../lib/service/TaskQueueService';

// Component
import component from './positionDisplayBox.component';

// Dependencies
import positionDetailsModal from '../positionDetailsModal';
import claimsModal from '../claimsModal';
import constants from '../../../../../lib/constants';
import filters from '../../../../../lib/filters';

const moduleName = 'staff.dashboardScreen.positionDisplayBox';
let module = angular.module(moduleName, [
  'recaps.services',
  translation,
  'angularMoment',
  'geolocation',
  positionDetailsModal.name,
  claimsModal.name,
  positionDetailsModal.name,
  constants,
  filters.name,
  taskQueueServiceModule.name
]);

module.component('positionDisplayBox', component);

export default module;
